<template>
    <div class="page-wrap">
        <div class="page-main">
            <div class="title-wrap">
                <div class="logo">
                    <img src="../../assets/logo.png" alt="综合体数字云仓">
                </div>
                <div class="title">找回密码</div>
            </div>
            <div class="form-wrap">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                    <el-form-item prop="phone" size="small">
                        <el-input type="text" v-model.trim="ruleForm.phone" autocomplete="off"
                            placeholder="请输入您的手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="code" size="small" class="code-line">
                        <el-input type="text" v-model.trim="ruleForm.code" autocomplete="off"
                            placeholder="请输入您的验证码"
                        ></el-input>
                        <button class="code-btn" type="button" @click="sentCodeHandle">{{sentCodeText}}</button>
                    </el-form-item>
                    <el-form-item prop="passWd" size="small">
                        <el-input type="password" v-model.trim="ruleForm.passWd" autocomplete="off"
                            placeholder="请输入您的密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="checkPassWd" size="small">
                        <el-input type="password" v-model.trim="ruleForm.checkPassWd" autocomplete="off"
                            placeholder="请再次输入您的密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <button type="button" class="submit-btn" @click="submitForm">确认</button>
                    </el-form-item>
                </el-form>
            </div>
            
        </div>
    </div>
</template>

<script>
import { validateMobile, validateCombinationPwd } from '../../utils/validate'
import { RequestPhoneCode, RequestForgetPassWd } from '../../api/public'
export default {
    data() {
      var validatePhone =  (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号'))
        } else if (!validateMobile(value)){
          callback(new Error('手机号格式不正确'))
        } else {
          callback()
        }
      }

      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else if (!validateCombinationPwd(value)){
          callback(new Error('密码格式不正确，请输入6-16位组合密码'))
        } else {
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value != this.ruleForm.passWd){
          callback(new Error('两次密码输入不一致'))
        } else {
          callback()
        }
      }
      return {
        ruleForm: {
          phone: '',
          code: '',
          passWd: '',
          checkPassWd: ''
        },
        rules: {
          phone: [
            { validator: validatePhone, trigger: 'change' }
          ],
          code: [
            { required: true, message: "请输入验证码", trigger: 'change' }
          ],
          passWd: [
            { validator: validatePass, trigger: 'change' }
          ],
          checkPassWd: [
            { validator: validatePass2, trigger: 'change' }
          ]
        },
        // 验证码相关
        sentCodeBtn: true,
        sentCodeText: '发送验证码',
        sentCodeTimer: null,
      }
    },
    methods: {
      submitForm() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            RequestForgetPassWd({
              phone: this.ruleForm.phone,
              code:  this.ruleForm.code,
              passWd:  this.ruleForm.passWd,
              checkPassWd:  this.ruleForm.checkPassWd,
            }).then(res => {
              console.log(res)
              if (res.errorCode == 200) {
                this.$message.success('密码设置成功')
                this.$router.push('/login')
              } else {
                this.$message.error(res.errorMsg || '密码设置失败')
              }
            }).catch(err => {
              console.log(err)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      // 获取验证码
      sentCodeHandle() {
          if (this.sentCodeBtn) {
              this.$refs['ruleForm'].validateField('phone', (err) => {
                console.log(err)
                if (!err) {
                  RequestPhoneCode(this.ruleForm.phone).then(res => {
                      console.log(res)
                      if (res.errorCode == 200) {
                          this.$message.success('验证码发送成功')
                      } else {
                          this.$message.error('验证码发送失败')
                      }
                  }).catch(err => {
                      console.log(err)
                  })
                  this.sentCodeBtn = false
                  let t = 60
                  this.sentCodeText = t + 's'
                  clearInterval(this.sentCodeTimer)
                  this.sentCodeTimer = setInterval(() => {
                      if (t > 0) {
                          t --
                          this.sentCodeText = t + 's'
                      } else {
                          this.sentCodeText = '获取验证码'
                          this.sentCodeBtn = true
                          clearInterval(this.sentCodeTimer)
                      }
                  }, 1000)
                }
              })

              
          }
      }
    }
  }
</script>

<style lang="scss" scoped>
.page-wrap {
    height: 100%;
    background: #fff;
    .page-main {
        padding-top: 80px;
        width: 354px;
        margin: 0 auto;
        .title-wrap {
            .logo {
                margin-left: -8px;
                img { width: 228px; display: block;}
            }
            .title {
                margin-top: 30px;
                font-size:24px;
                font-weight:600;
                color:rgba(42,46,63,1);
                color:rgba(51,51,51,1);
                line-height:20px;
                letter-spacing: 2px;
            }
        }
        .form-wrap {
            padding-top: 30px;
            .code-line {
                .el-input {
                    position: relative;
                    width: 224px;
                }
                .code-btn {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 116px;
                    height: 32px;
                    background:rgba(255,255,255,1);
                    border-radius: 4px;
                    border:1px solid rgba(248,29,34,0.5);
                    font-size:14px;
                    color:rgba(248,29,34,1);
                    outline: none;
                }
            }
            .submit-btn {
                margin-top: 30px;
                width: 100%;
                height:40px;
                background:rgba(225,16,16,1);
                border-radius:4px;
                font-size:16px;
                font-weight: normal;
                color:rgba(255,255,255,1);
                letter-spacing:1px;
                border: none;
                outline: none;
                &.opa {opacity: 0.6;}
            }
        }
    }
}
</style>